import { Link } from "@inertiajs/react";
import Icon from "hardcover-ui/components/Icon";
import faTiktok from "icons/brands/tiktok.svg";
import faYoutube from "icons/brands/youtube.svg";
import faInstagram from "icons/brands/instagram.svg";
import faPhotoVideo from "icons/solid/photo-film.svg";

export interface MediaLinkProps {
  url: string;
}

const iconForUrl = (url): any => {
  try {
    const parsedUrl = new URL(url);

    if (parsedUrl.host.indexOf("youtube") !== -1) {
      return faYoutube;
    }
    if (parsedUrl.host.indexOf("tiktok") !== -1) {
      return faTiktok;
    }
    if (parsedUrl.host.indexOf("instagram") !== -1) {
      return faInstagram;
    }
    return faPhotoVideo;
  } catch {
    return faPhotoVideo;
  }
};

const MediaLink = ({ url }: MediaLinkProps) => {
  const icon = iconForUrl(url);

  return (
    <Link
      href={url}
      target="_blank hover:text-yellow-300"
      rel="noreferrer nofollow"
    >
      <Icon
        icon={icon}
        size="md"
        className="hover:fill-yellow-300 fill-gray-300"
      />
    </Link>
  );
};

export default MediaLink;
